/**
 * Eleccion de modalidades del catalogo global para una institucion.
 *
 * @module presentation/components/admin/SelectorDeTiposDeEstudio
 */

export interface TipoDeEstudioDelCatalogo {
  code: string
  name: string
  description?: string | null
}

interface Props {
  tipos: readonly TipoDeEstudioDelCatalogo[]
  seleccionados: Set<string>
  onCambiar: (seleccionados: Set<string>) => void
  titulo?: string
}

export function SelectorDeTiposDeEstudio({
  tipos,
  seleccionados,
  onCambiar,
  titulo = 'Tipos de estudio',
}: Props) {
  const alternar = (code: string, marcado: boolean) => {
    const siguiente = new Set(seleccionados)
    if (marcado) siguiente.add(code)
    else siguiente.delete(code)
    onCambiar(siguiente)
  }

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between">
        <p className="text-sm font-medium">{titulo}</p>
        <div className="flex gap-3 text-xs text-[var(--foreground-muted)]">
          <button
            type="button"
            className="hover:text-[var(--foreground)] underline"
            onClick={() => onCambiar(new Set(tipos.map((t) => t.code)))}
          >
            Todos
          </button>
          <button
            type="button"
            className="hover:text-[var(--foreground)] underline"
            onClick={() => onCambiar(new Set())}
          >
            Ninguno
          </button>
          <span>
            {seleccionados.size}/{tipos.length} seleccionados
          </span>
        </div>
      </div>
      <div className="rounded-lg border divide-y">
        {tipos.map((tipo) => (
          <label
            key={tipo.code}
            className="flex items-start gap-3 px-3 py-2.5 cursor-pointer hover:bg-[var(--muted)] transition-colors"
          >
            <input
              type="checkbox"
              checked={seleccionados.has(tipo.code)}
              onChange={(e) => alternar(tipo.code, e.target.checked)}
              className="mt-0.5 h-4 w-4 rounded flex-shrink-0"
            />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <span className="font-mono text-xs text-[var(--foreground-muted)] flex-shrink-0">
                  {tipo.code}
                </span>
                <span className="text-sm font-medium truncate">{tipo.name}</span>
              </div>
              {tipo.description && (
                <p className="text-xs text-[var(--foreground-muted)] mt-0.5 line-clamp-1">
                  {tipo.description}
                </p>
              )}
            </div>
          </label>
        ))}
      </div>
    </div>
  )
}
